import { get, patch } from 'services/http';

const getEntitiesByClass = ({ classUri, query, start, limit }) => {
  const encodedClassUri = encodeURIComponent(classUri);
  return get(`/knowledge-graph/classes/${encodedClassUri}/entities`, {
    addKgId: true,
    query: query || '',
    start: start || 0,
    limit: limit || 20
  });
};

const getEntity = uri => {
  return get(`/knowledge-graph/entities/${encodeURIComponent(uri)}`);
};

const updateEntity = (uri, body) => {
  return patch(`/knowledge-graph/entities/${encodeURIComponent(uri)}`, JSON.stringify(body), null, { addKgId: true });
};

export default { getEntitiesByClass, getEntity, updateEntity };
